import { render, staticRenderFns } from "./corpus-selector.vue?vue&type=template&id=2a80415d&"
import script from "./corpus-selector.vue?vue&type=script&lang=js&"
export * from "./corpus-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports